import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import "../styles/nav.scss";
import i18n from "../i18n";

const SimpleHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const switchLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  const isLoggedIn = localStorage.getItem("token");

  // Don't show on login page or if not logged in
  if (
    location.pathname === "/login" ||
    location.pathname === "/first-login" ||
    location.pathname === "/404" ||
    !isLoggedIn
  )
    return null;

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleHome = () => {
    navigate("/");
    handleMenuClose();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
    handleMenuClose();
  };

  return (
    <header className="simple-header">
      <div className="simple-header__left" onClick={() => navigate("/")}>
        <h1 className="simple-header__title">PMW AI Platform</h1>
      </div>

      <div className="simple-header__right">
        <IconButton
          onClick={handleMenuOpen}
          className="simple-header__menu-icon"
        >
          <MenuIcon sx={{ color: "#FFF" }} fontSize="large" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          disableScrollLock={true}
        >
          <MenuItem onClick={handleHome}>Home</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
          <MenuItem onClick={() => switchLanguage("en")}>🇬🇧 English</MenuItem>
          <MenuItem onClick={() => switchLanguage("es")}>🇪🇸 Español</MenuItem>
        </Menu>
      </div>
    </header>
  );
};

export default SimpleHeader;
